import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { TMoneySourcesState } from '../../../../../reducers/v2';
import { EAvailableMoneySources } from '../../../../../repositories/billing-tariffs/entities/PublishTerms/GetPublishTermsResponseV2';
import { EMoneySource } from '../../../../../types/reducers/user';
import { defaultTo } from 'lodash';

export const mapMoneySources = (response: IAddFormPublishTermsResponse): TMoneySourcesState => {
  const availableMoneySources = response.availableMoneySources;
  const selectedMoneySource = defaultTo(response.moneySource, EMoneySource.Self);

  return [
    {
      type: EMoneySource.Master,
      disabled: availableMoneySources === EAvailableMoneySources.Self,
      selected: selectedMoneySource === EMoneySource.Master,
    },
    {
      type: EMoneySource.Self,
      disabled: availableMoneySources === EAvailableMoneySources.Master,
      selected: selectedMoneySource === EMoneySource.Self,
    },
  ];
};
